<template>
  <div class="por-benefits pt-4 pr-8 pb-4 pl-8">
    <ul class="por-benefits-list">
      <li
        class="por-benefits-item-wrapper"
        data-qa="por-benefits-item-wrapper">
        <div class="por-benefits-item">
          <div class="por-benefits-icon-wrapper">
            <svg class="por-benefits-icon" data-qa="por-benefits-icon" height="45px" viewBox="0 0 48 45" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <title>574E260B-A9CE-4E29-8F43-1094E982984C</title> <desc>Created with sketchtool.</desc> <defs></defs> <g id="New-Registration-Page-Layout" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Zava-large-new-registration-layout-1.0" transform="translate(-790.000000, -357.000000)"> <g id="Zava-support" transform="translate(790.000000, 355.000000)"> <rect id="Rectangle-4" x="0" y="0" width="48" height="48"></rect> <g id="Group" transform="translate(0.000000, 2.000000)" stroke="#1E90FF" stroke-linejoin="round"> <g id="Group-510"> <path d="M47,20.1713455 C47,30.7460551 36.704,39.3225713 24,39.3225713 C21.164,39.3225713 18.45,38.8939496 15.942,38.1122252 L2.724,44.3905126 L7.9,33.8464188 C3.642,30.3705009 1,25.5270757 1,20.1713455 C1,9.59459472 11.296,1.02011965 24,1.02011965 C36.704,1.02011965 47,9.59459472 47,20.1713455 L47,20.1713455 Z" id="Stroke-249"></path> </g> <polygon id="Stroke-795" stroke-linecap="round" points="34.0645161 17.5483871 27.3548387 17.5483871 27.3548387 10.8387097 20.6451613 10.8387097 20.6451613 17.5483871 13.9354839 17.5483871 13.9354839 24.2580645 20.6451613 24.2580645 20.6451613 30.9677419 27.3548387 30.9677419 27.3548387 24.2580645 34.0645161 24.2580645"></polygon> </g> </g> </g> </g></svg>
          </div>
          {{ $t('common_benefits_text') }}
        </div>
      </li>
      <li
        class="por-benefits-item-wrapper"
        data-qa="por-benefits-item-wrapper">
        <div class="por-benefits-item">
          <div class="por-benefits-icon-wrapper">
            <svg class="por-benefits-icon" data-qa="por-benefits-icon" height="44" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g stroke="none" stroke-width="0.5" fill="none" fill-rule="evenodd">
                <path d="M12.04 23.5C18.3913 23.5 23.54 18.3513 23.54 12C23.54 5.64873 18.3913 0.5 12.04 0.5C5.68876 0.5 0.540039 5.64873 0.540039 12C0.540039 18.3513 5.68876 23.5 12.04 23.5Z" stroke="#1E90FF" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11.54 6.5V12L17.54 17.5" stroke="#1E90FF" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
            </svg>
          </div>
          {{ $t('commonBenefits_deliveryMsg_text') }}
        </div>
      </li>
      <li
        class="por-benefits-item-wrapper"
        data-qa="por-benefits-item-wrapper">
        <div class="por-benefits-item">
          <div class="por-benefits-icon-wrapper">
            <svg class="por-benefits-icon mx-auto" data-qa="por-benefits-icon" height="42px" viewBox="0 0 36 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <title>34A46AC6-27C4-494A-9406-F4AE5CFE7820</title> <desc>Created with sketchtool.</desc> <defs></defs> <g id="New-Registration-Page-Layout" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Zava-large-new-registration-layout-1.0" transform="translate(-796.000000, -514.000000)"> <g id="Zava-medication" transform="translate(790.000000, 511.000000)"> <rect id="Rectangle-4-Copy-2" x="0" y="0" width="48" height="48"></rect> <g id="Group-2" transform="translate(7.000000, 4.000000)" stroke="#1E90FF" stroke-linecap="round" stroke-linejoin="round"> <g id="Page-1" transform="translate(17.241379, 20.000000) rotate(-360.000000) translate(-17.241379, -20.000000) "> <path d="M33.1034483,4.13793103 L33.1034483,34.6206897 C33.1034483,37.5775172 30.5823124,40 27.505071,40 L6.97768763,40 C3.89858012,40 1.37931034,37.5775172 1.37931034,34.6206897 L1.37931034,4.13793103" id="Stroke-1"></path> <path d="M34.4827586,4.13793103 L0,4.13793103 L0,2.06896552 C0,0.925517241 1.21597096,0 2.72232305,0 L31.7604356,0 C33.2631579,0 34.4827586,0.925517241 34.4827586,2.06896552 L34.4827586,4.13793103 Z" id="Stroke-3"></path> <polygon id="Stroke-5" points="5.51724138 31.7241379 28.9655172 31.7241379 28.9655172 8.27586207 5.51724138 8.27586207"></polygon> <polygon id="Stroke-7" points="24.8275862 18.3908046 19.7701149 18.3908046 19.7701149 13.7931034 14.7126437 13.7931034 14.7126437 18.3908046 9.65517241 18.3908046 9.65517241 22.9885057 14.7126437 22.9885057 14.7126437 27.5862069 19.7701149 27.5862069 19.7701149 22.9885057 24.8275862 22.9885057"></polygon> </g> </g> </g> </g> </g></svg>
          </div>
          {{ $t('common_benefitsMedication_text') }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'por-benefits'
}
</script>

<style lang="scss">
  $por-benefits-shadow: 0 0 16px 0 rgba(0,0,0,0.2);
  $por-benefits-margin-top: 4px;

  $por-benefits-list-max-width-xs: 600px;
  $por-benefits-list-padding-xs: 0 15px;

  $por-benefits-item-font-size: 1.4rem;

  $por-benefits-icon-height: 40px;
  $por-benefits-icon-height-xs: 25px;
  $por-benefits-icon-margin-right: 12px;

  .por-benefits {
    width: 100%;
    margin-top: $por-benefits-margin-top; // To compensate for header border
    box-shadow: $por-benefits-shadow;
    font-size: 16px;
  }

  .por-benefits-list {
    display: flex;
    gap: 16px;
    align-content: center;
    justify-content: space-between;
  }

  .por-benefits-item-wrapper {
    display: flex;
    flex: 1 1 0px;
    justify-content: center;
  }

  .por-benefits-item {
    display: flex;
    align-items: center;
  }

  .por-benefits-icon-wrapper {
    margin-right: $por-benefits-icon-margin-right;
  }

  .por-benefits-icon {
    height: $por-benefits-icon-height;
    display: block;
  }

  @media(max-width: 1200px) {
    .por-benefits {
      margin-top: 3px;
    }
  }

  @media(max-width: 768px) {
    .por-benefits-list {
      font-size: 14px;
      display: flex;
      max-width: $por-benefits-list-max-width-xs;
      margin: 0 auto;
      flex-direction: column;
      gap: 8px;
    }

    .por-benefits-item-wrapper {
      margin-right: $por-benefits-icon-margin-right;
      justify-content: start;
    }

    .por-benefits-icon-wrapper {
      display: inline-block;
      width: $por-benefits-icon-height-xs;
      min-width: $por-benefits-icon-height-xs;
      text-align: center;
    }

    .por-benefits-icon {
      height: $por-benefits-icon-height-xs;
    }
  }
</style>
